import { useEffect, useState } from 'react';
import { isFirefox } from 'react-device-detect';
export const useCheckOnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(true);
    useEffect(() => {
        let intervalId;
        const checkOnlineStatus = () => {
            const status = navigator.onLine;
            setIsOnline(status);
        };
        if (isFirefox) {
            intervalId = window.setInterval(() => checkOnlineStatus(), 1000);
        }
        return () => {
            window.clearInterval(intervalId);
        };
    }, []);
    useEffect(() => {
        const checkOnlineStatus = () => {
            const status = navigator.onLine;
            if (status) {
                setIsOnline(true);
            }
            else {
                setIsOnline(false);
            }
        };
        window.addEventListener('online', checkOnlineStatus);
        window.addEventListener('offline', checkOnlineStatus);
        return () => {
            window.removeEventListener('online', checkOnlineStatus);
            window.removeEventListener('offline', checkOnlineStatus);
        };
    }, []);
    return {
        isOnline,
    };
};
